export default __webpack_public_path__ + "assets/c869b8918de8e89ba26c66516c0a167e/residents.png";